import { Type, constrain, Constraint } from "specified";
const integerSpec = constrain(Type.number, [Constraint.number.integer]);
const positiveIntegerSpec = constrain(integerSpec, [Constraint.number.atLeast(0)]);
const integerAbove0 = constrain(integerSpec, [Constraint.number.above(0)]);
const isoDateSpec = Type.string;
const dateStringSpec = {
  version: 1,
  definition: {
    type: "dateString"
  },
  eval: (value) => {
    const ts = Date.parse(`${value}`);
    if (ts % 1 !== 0) {
      return { err: { code: "type.dateString.not_valid", value, message: "Not a valid date." } };
    }
    return { err: null, value: new Date(ts) };
  }
};
Constraint.string.regex(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
export {
  dateStringSpec,
  integerAbove0,
  integerSpec,
  isoDateSpec,
  positiveIntegerSpec
};
//# sourceMappingURL=specs-utils.js.map
